var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-image-selector"
  }, [_vm._t("trigger", function () {
    return [!_vm.image ? _c('button', {
      on: {
        "click": _vm.openFileSelector
      }
    }, [_vm._v("Add Photo")]) : _vm._e()];
  }, {
    "openFileSelector": _vm.openFileSelector
  }), _c('input', {
    ref: "input",
    staticClass: "s-file-input",
    attrs: {
      "type": "file",
      "name": "image",
      "accept": "image/*"
    },
    on: {
      "change": function change($event) {
        return _vm.loadImage($event.target.files[0]);
      }
    }
  }), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.popupOpened ? _c('div', {
    staticClass: "s-popup"
  }, [_c('div', {
    staticClass: "s-popup-inner"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('button', {
    staticClass: "btn btn-outline-danger btn-sm s-cancel-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("取消")]), _c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitImage
    }
  }, [_vm._v("確定")])]), _c('div', [_c('img', {
    staticClass: "s-image",
    attrs: {
      "id": _vm.randomId,
      "src": _vm.image
    }
  })])])]) : _vm._e()])], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }